<template>

  <t-dialog-form :generalErrors="generalErrors" large :title="t(command) + ' Etapa'"
                 :ok-text="t(command) + ' Etapa'" @show="showModal" @hidden="resetModal" :busy="busy" :id="id"
                 :status="status" :command="command"
                 ref="dialog_form" @onSubmit="onSubmit">


    <t-input v-model="form.processFlowStepId" hidden/>

    <b-row>

      <b-col cols="6">

        <div class="d-flex" style="justify-content: space-between">

          <div>Etapa</div>


        </div>

        <t-input v-model="form.name"  hide-label :add-error="error.name" label="Etapa"
                 required/>

      </b-col>

      <t-input cols="6" v-model="form.note" label="Observação"/>

    </b-row>


    <b-row class="bg-warning-alert" v-if="!form.stepSequential">

      <div class="col-12 font-italic"><small>Opções para etapa não sequencial</small></div>

      <b-col cols="6">

        <t-input select-common
                 v-model="form.typeActionNotSequential" :options="FlowStepNotSequenceActionType.list"
                 :add-error="error.typeActionNotSequential" label="Tipo não sequêncial"
                 required/>

      </b-col>

      <b-col cols="3" v-if="form.typeActionNotSequential === FlowStepNotSequenceActionType.type.EXECUTION_PARALLEL">

        <t-input select-common
                 v-model="form.startProcessFlowStepId" :options="otherStepsSerial"
                 :add-error="error.startProcessFlowStepId" label="Finalizar durante"
                 help="Etapa que deverá estar em andamento ou finalizada para que esta etapa em paralelo possa ser executada"
                 required/>

      </b-col>

      <b-col cols="3" v-if="form.typeActionNotSequential === FlowStepNotSequenceActionType.type.EXECUTION_PARALLEL">

        <t-input select-common
                 v-model="form.endProcessFlowStepId" :options="otherStepsSerial"
                 :add-error="error.endProcessFlowStepId" label="Finalizar antes"
                 help="Etapa máxima que não poderá ser finalizada antes que esta etapa em paralelo esteja concluída"
                 required/>

      </b-col>

      <b-col cols="6" v-if="form.typeActionNotSequential === FlowStepNotSequenceActionType.type.RETURN_SPECIFIC_STEP">

        <t-input select-common
                 v-model="form.goProcessFlowStepId" :options="otherStepsAll"
                 :add-error="error.goProcessFlowStepId" label="Etapa desejada"
                 required/>

      </b-col>

    </b-row>

    <b-row>


      <t-input radio cols="4" v-model="form.deadlineType" :options="deadlineTypeOptions"
               :add-error="error.deadlineType" label="Cálculo do Tempo"
               required/>

      <t-input v-show="form.deadlineType === 1" cols="8" number v-model="form.deadlineFixedMinutes"
               :add-error="error.deadlineFixedMinutes"
               label="Tempo fixo em minutos fixo"
               help="Valor fixo em minutos independente da quantidade de peças"
               :required="form.deadlineType === 1"/>


      <t-input v-show="form.deadlineType === 2" cols="8" v-model="form.deadlineRegex" :add-error="error.deadlineRegex"
               label="Fórmula com base na quantidade"
               help="Resultado será em minutos. Utilize a variáveis de sistema: [QUANTITY_PIECES]  e também as tags dos campos no padrão {TAG}. Exemplo: ([QUANTITY_PIECES]*1) + ([QUANTITY_PIECES]*{TEMPO_VULCANIZACAO})"
               :required="form.deadlineType === 2"/>


    </b-row>


    <t-input select-common required v-model="form.operationStatusId" :options="typeStatusProductionOptions"
             :add-error="error.operationStatusId" label="Status Operacional"
             help="Informe qual o status operacional da Ordem de Fabricação quando esta etapa estiver em andamento."/>


    <!--      <t-input select-common required v-model="form.specialType" cols="4" :options="specialTypeOptions"
                   :add-error="error.specialType" label="Etapa tipo especial"
                   help="Utilizado para ações especiais com conteúdo relacionado a setores produtivos relacionados"/>

          <t-input select-common required v-model="form.negationType" cols="4" :options="negationTypeOptions"
                   :add-error="error.negationType" label="Etapa permite lançar perda"
                   help="Utilizado para habilitar lançamento de perdas na Ordem de Produção"/>-->


    <t-input radio v-model="form.responsibleType" :options="responsibleTypeOptions"
             :add-error="error.responsibleType" label="Tipo de Responsável"
             required/>


    <t-input v-show="form.responsibleType === 1" select :options="operatorOptions" v-model="form.operatorId"
             :add-error="error.operatorId"
             label="Operador" :required="form.responsibleType === 1"/>


    <b-row v-show="form.responsibleType === 2">

      <t-input cols="8" v-model="groupUserId" select :options="groupUserOptions"
               label="Grupo de Usuários"/>

      <b-col cols="4">
        <t-button outline-primary form-inline @click="addGroupUser">Adicionar</t-button>

      </b-col>

    </b-row>


    <b-list-group v-show="form.responsibleType === 2">

      <b-list-group-item class="m-0 p-0" v-for="item in form.groupUsers" :key="item.groupUserId">

        <b-row class="d-flex align-items-center">

          <div class="col-6 d-flex align-items-center">

            <b class="pl-2">{{ item.name }}</b>

          </div>

          <t-input radio cols="5" v-model="item.stepTypeAccess" :options="FlowStepGroupUserAccessType.list"/>

          <div class="col-1">

            <b-icon-trash @click="addGroupSelected(false, item.groupUserId)" class="text-danger opacity-6 opacity-10-hover link" />

          </div>

        </b-row>


      </b-list-group-item>

    </b-list-group>

    <b-card title="Configurações Adicionais">

      <b-row>


        <b-col cols="6">


          <b-form-checkbox v-model="form.startAutomatically" switch>
            Início automático?
            <t-help
                title="Deixe esta opção marcada indicando que quando chegar o momento desta etapa a mesma será iniciada automaticamente para o operador relacionado, caso contrário o operador deverá realizar o início manual."/>
          </b-form-checkbox>


          <b-form-checkbox v-model="form.stepSequential" switch>
            Sequenciável?
            <t-help
                title="Deixe esta opção marcada indicando que é uma etapa continua ou desmarque a etapa e desta forma somente poderá ser acessada via Ação Especial."/>
          </b-form-checkbox>

          <b-form-checkbox v-model="form.enableCopyOtherStep" switch>
            Permite copiar dados?
            <t-help
                title="Deixe esta opção marcada indicando que é uma etapa que pode ter os dados copiados de outra Ordem de Fabricação."/>
          </b-form-checkbox>

        </b-col>

        <b-col cols="6">

          <b-form-checkbox v-model="form.finishAutomaticallyEnable" switch>
            Finalizar automaticamente em relação a data de produção (minutos)?
            <t-help
                title="Marque esta opção se deseja finalizar a etapa automaticamente em relação a data de produção, sendo o prazo em MINUTOS."/>
          </b-form-checkbox>


          <t-input :disabled="!form.finishAutomaticallyEnable" v-show="form.finishAutomaticallyEnable"
                   :required="form.finishAutomaticallyEnable"
                   v-model="form.finishAutomaticallyDeadline" placeholder="Prazo em minutos após inicio"
                   label="Após quantos minutos?" hide-label/>


        </b-col>

      </b-row>


    </b-card>


  </t-dialog-form>


</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import http from "@/services/config/http-common";
import MaskMinuteType from "@/model/types/resource/MaskMinuteType";
import FlowStepNotSequenceActionType from "@/model/types/modules/production/FlowStepNotSequenceActionType";
import FlowStepGroupUserAccessType from "@/model/types/modules/production/FlowStepGroupUserAccessType";
import ui from "@/assets/scripts/ui";


export default {
  name: 'ProcessFlowStepDialog',
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      MaskMinuteType,
      FlowStepNotSequenceActionType,
      FlowStepGroupUserAccessType,
      id: "modal-process-flow-step",
      path: "production/process-flow-step", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "processFlowStepId",
      foreignKeyColumn: "processFlowId", //Utilizar quando usar Tabs com outros componentes
      form: {
        processFlowStepId: this.processFlowStepId,
        processFlowId: this.foreignKey,
        operationStatusId: 0,
        stepSequential: true,
        responsibleType: 2,
        departmentId: 0,
        operatorId: 0,
        deadlineType: 1,
        deadlineFixedMinutes: 0,
        deadlineRegex: "",
        specialType: 1,
        negationType: 1,
        startAutomatically: false,
        enableCopyOtherStep: false,
        finishAutomaticallyEnable: false,
        finishAutomaticallyTypeMaskMinute: MaskMinuteType.type.MINUTE,
        finishAutomaticallyDeadline: 0,
        typeActionNotSequential: FlowStepNotSequenceActionType.type.RETURN_NEXT_STEP_ORIGIN,
        goProcessFlowStepId: 0,
        startProcessFlowStepId: 0,
        endProcessFlowStepId: 0,
        name: "",
        note: "",
        status: 1,
        groupUsers: [],
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        responsibleType: "",
        departmentId: "",
        operatorId: "",
        deadlineType: "",
        deadlineFixedMinutes: "",
        deadlineRegex: "",
        specialType: "",
        negationType: "",
        typeActionNotSequential: "",
        goProcessFlowStepId: "",
        startProcessFlowStepId: "",
        endProcessFlowStepId: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      groupUserId: 0,
      operatorOptions: [],
      departmentOptions: [],
      originalGroupUserOptions:[],//Armazena a listagem original sem manipulação
      groupUserOptions: [],
      typeStatusProductionOptions: [],
      otherStepsAll: [],
      otherStepsSerial: [],

      responsibleTypeOptions: [{value: 2, text: "Grupo de Usuários"}, {value: 1, text: "Operador específico"}],
      deadlineTypeOptions: [{value: 1, text: "Fixo"}, {value: 2, text: "Fórmula"}],
      specialTypeOptions: [{value: 1, text: "Não"}, {value: 2, text: "Matéria-Prima"}, {
        value: 3,
        text: "Componentes"
      }, {value: 4, text: "Produção"}],
      negationTypeOptions: [{value: 1, text: "Não"}, {value: 2, text: "Sim, qualquer tipo de perda"}, {
        value: 3,
        text: "Sim, somente quantidade de peças"
      }, {value: 4, text: "Sim, matéria-prima"}, {value: 5, text: "Sim, componentes"}],

    }
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {


      this.busy = true

      //Limpa os campos
      this.resetModal()

      //Setar alguma informações padrão por exemplo vindo de fora
      this.originalGroupUserOptions = []
      this.form.processFlowStepId = this.primaryKey
      this.form.processFlowId = this.foreignKey
      this.form.stepSequential = true
      this.form.responsibleType = 2
      this.form.deadlineType = 1
      this.form.specialType = 1
      this.form.negationType = 1
      this.form.status = 1
      this.form.groupUsers = []

      //Coreção para atualização de chave
      setTimeout(async () => {

        await http.list(this.path + "/selectRelationList?processFlowId=" + this.foreignKey + "&processFlowStepId=" + this.form.processFlowStepId).then((list) => {

          this.operatorOptions = list.operatorOptions
          this.departmentOptions = list.departmentOptions
          this.typeStatusProductionOptions = list.typeStatusProductionOptions
          this.otherStepsAll = list.otherStepsAll
          this.otherStepsSerial = list.otherStepsSerial
          this.groupUserOptions = list.groupUserOptions
          this.originalGroupUserOptions = this.groupUserOptions.slice()

        }).catch(error => this.responseError(error))

        await this.readModal(false)

        this.setGroupUserAvailable()

        this.busy = false

      }, 50)


    },

    setGroupUserAvailable(){

      //Seta a informação inicial
      if (this.form.groupUsers.length > 0) {

        for (let item of this.form.groupUsers) {

          //Tenta encontra item na listagem de grupos ativos
          const group = this.groupUserOptions.find(a => a.value === item.groupUserId)

          if (group) {

            //Encontrado então seta o texto somente
            item.name = group.text

            //Remove da listagem
            const indexRemove = this.groupUserOptions.findIndex(a => a.value === item.groupUserId)

            if (indexRemove >= 0)
              this.groupUserOptions.splice(indexRemove, 1)

          } else {
            //Remove, pois provavelmente não é mais válido o grupo que havia sido selecionado
            this.addGroupSelected(false, item.groupUserId)
          }

        }

      }

    },

    async onSubmit() {

      if(this.form.responsibleType === 2 && this.form.groupUsers.length === 0){
        ui.msgError(this,"Selecione pelo menos 1(um) grupo de usuários ou altere a responsabilidade para operador específico.")
      }else{
        //Validações específicas da tela
        await this.setSubmitDialogDefault()
      }

    },

    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    addGroupUser() {

      if (this.groupUserId === 0) {
        ui.msgError(this, 'Selecione o grupo que deseja selecionar')
      } else {

        this.addGroupSelected(true, this.groupUserId)
        this.groupUserId = 0

      }

    },


    addGroupSelected(checked, id) {

      if (checked) {

        const el = this.form.groupUsers.find(a => a.groupUserId === id)

        //Não inserido anteriormente
        if (el == null) {

          //Encontra item na listagem
          const item = this.groupUserOptions.find(a => a.value === id)

          //Adiciona
          this.form.groupUsers.push(
              {
                groupUserId: id,
                name: item.text,
                stepTypeAccess: FlowStepGroupUserAccessType.type.FULL
              }
          )

          //Remove da listagem, pois já foi utilizado
          const indexRemove = this.groupUserOptions.findIndex(a => a.value === id)

          if (indexRemove >= 0)
            this.groupUserOptions.splice(indexRemove, 1)

        }

      } else {
        //Remover
        const indexRemove = this.form.groupUsers.findIndex(a => a.groupUserId === id)

        if (indexRemove >= 0){

          //Remove da listagem
          this.form.groupUsers.splice(indexRemove, 1)

          //Tenta encontrar para disponibilizar novamente para seleção
          const original = this.originalGroupUserOptions.find(a => a.value === id)

          //Encontrado na lista original, por tanto retorna para listagem disponivel
          if(original){
            this.groupUserOptions.push(original)
          }

        }


      }

    },

    //--------------------------------------------------------------------------------------
  },
}
</script>
